import Vue from 'vue';
import Vuex from 'vuex';
import Xhr from "./utils/Xhr";
Vue.use(Vuex);

const state = {
	notifications:[],
	modalClickPos:{
		x:30,
		y:30
	},
	modalPos:{
		x:0,
		y:0
	},
	rrweb:[],
};

const getters = {
	notifications: state => {
		return state.notifications;
	},
	notifications_nb: state => {
		return state.notifications.length;
	},
	rrweb: state => {
		return state.rrweb
	},
};

const actions = {

};

const mutations = {
	notifDeleteAll:function(state){
		state.notifications = [];
	},
	notifDelete:function(state, id){
		for(let i=0; i<state.notifications.length; i++){
			// console.log("deleteNotification", state.notifications[i].id, id);
			if(state.notifications[i].id === id){
				// delete state.notifications[i];
				state.notifications.splice(i, 1);
			}
		}
	},
	notifPush:function(state, data){
		let id = Math.floor(Math.random()*1000);
		let d = Object.assign({}, {id:id}, data);
		let index = null;
		for(let i=0; i<state.notifications.length; i++){
			if(state.notifications[i].id === d.id){
				index = i;
				state.notifications.splice(i, 1);
			}
		}
		if(index){
			state.notifications[index] = d;
		}else{
			state.notifications.push(d);
		}
		// console.log("app.js mutations mutations", d, state.notifications.length);
	},
	// modalAddOffsetY:function(state, patate){
	// 	state.modalPos.y = state.modalPos.y + patate;
	// },
	documentsSetUnread: function(state, nb){
		state.documentsUnread.nb = nb;
	},
	modalSetPos: function(state, pos){
		state.modalPos = pos;
	},
	setModalClickPos: function(state, event){
		state.modalClickPos = {
			x: event.clientX,
			y: event.clientY,
		}
	},
	rrweb(state, data){
		let datas = {
			app:2,
			copid:null,
			uid:null,
			tid:state.token && state.token.tid ? state.token.tid : null,
			data:data
		};
		(new Vue()).$socket.client.emit('rrweb', datas);
	},
}

const store = new Vuex.Store({
	state,
	getters,
	actions,
	mutations,
});

export default store;
